import React from 'react';

const markup = String.raw`<div class="card">
<div class="card-head"><p class="card-title">Invoice status</p><span class="click-tag">Click a stage ↓</span></div>
<div class="exception-grid" id="vendInvoiceStageGrid"></div>
</div>`;

export default function InvoiceStatusCard() {
  return <div className="raw-fragment" dangerouslySetInnerHTML={{ __html: markup }} />;
}
